export const GOAL_WEIGHTS = {
  // tabela unica: antes havia duas copias que divergiam no defensivo e na sobrevenda
  return: {mcProb:0.35, sharpe:0.25, mcMedian:0.20, sortino:0.10, var95:0.05, beta:0.05},
  defensive: {var95:0.25, volatility:0.20, beta:0.20, sortino:0.20, sharpe:0.10, mcProb:0.05},
  concentration: {hhi:0.60, beta:0.20, volatility:0.10, var95:0.05, sharpe:0.05},
  dca: {mcProb:0.40, sharpe:0.35, mcMedian:0.25},
  oversold: {sharpe:0.40, mcProb:0.30, sortino:0.20, mcMedian:0.10}
}

// Pilar Perspectiva do Premium Score. Existia em DUAS copias (analise da 🧠 e
// card da 💎) — a regua antiga zerava tudo abaixo de 30% de prob+, e a correcao
// de 18/08 precisou ser feita nos dois lugares.
export const pilarPerspectiva = (prob) => Math.min(100, Math.max(0, (parseFloat(prob)||0) / 50 * 100))
// Pesos do score, na ordem estrutura/risco/diversificacao/momentum/perspectiva
export const PESOS_SCORE = { estrutura: 0.25, risco: 0.25, diversif: 0.2, momentum: 0.15, perspectiva: 0.15 }
// fonte unica do Premium Score: a soma ponderada MAIS a regra do elo mais fraco
// (D ou pior, <30, limita a 69; F, <23, limita a 49). Antes existia uma copia
// escrita a mao na analise da 🧠 e outra no card da 💎
export function scorePremium(estrutura, risco, diversif, momentum, perspectiva) {
  const P = PESOS_SCORE
  const bruto = Math.round(estrutura*P.estrutura + risco*P.risco + diversif*P.diversif + momentum*P.momentum + perspectiva*P.perspectiva)
  const pilares = [{n:"Estrutura", v:estrutura}, {n:"Risco", v:risco}, {n:"Diversificação", v:diversif}, {n:"Momentum", v:momentum}, {n:"Cenários positivos", v:perspectiva}]
  const pior = pilares.reduce((a,b) => b.v < a.v ? b : a)
  const teto = pior.v < 23 ? 49 : pior.v < 30 ? 69 : 100
  return { bruto, total: Math.min(bruto, teto), pior, teto }
}


export const CRYPTO_ETFS = ["FBTC","FETH","IBIT","BITB","BSOL","ARKB","ETHA"]
export const BTC_ETFS = ["IBIT","FBTC","BITB","ARKB","GBTC"]


// Os cinco pilares do Premium Score. Viviam duplicados: uma
// copia no card e outra dentro do contexto do chat. Em
// 04/08/2026 o momentum foi recalibrado de *5 para *3 e a troca
// so pegou numa das duas copias, entao por dois meses a nota da
// tela e a que a IA via eram numeros diferentes para a mesma
// carteira. Corrigido e extraido em 09/10/2026 para que nao
// possa divergir de novo.
export function pilaresPremium(etfEnriched, portfolioStats, prices) {
  const tv = etfEnriched.reduce((s,p)=>s+(p.value||0),0)
  const btcEtfs = etfEnriched.filter(p=>BTC_ETFS.includes(p.symbol))
  const ethEtfs = etfEnriched.filter(p=>["ETHA","FETH","ETHW","ETHE","ETH"].includes(p.symbol))
  const hasDupBtc = btcEtfs.length > 1
  const hasDupEth = ethEtfs.length > 1
  const estrutura = Math.max(0, 100 - (etfEnriched.reduce((m,x)=>Math.max(m, tv>0?(x.value||0)/tv*100:0),0) > 25 ? 20 : 0) - (etfEnriched.filter(x=>["IBIT","FBTC","BITB","ARKB","GBTC","ETHA","FETH","ETHW","ETHE","ETH","BSOL"].includes(x.symbol)).reduce((a,x)=>a+(tv>0?(x.value||0)/tv*100:0),0) > 40 ? 20 : 0) - (hasDupBtc || hasDupEth ? 15 : 0) - (etfEnriched.length < 3 ? 15 : 0))
  const sharpe = parseFloat(portfolioStats?.sharpe_ratio) || 0
  const risco = Math.max(0, Math.min(100, sharpe >= 1 ? 90 : sharpe >= 0 ? 60 : sharpe >= -1 ? 35 : sharpe >= -2 ? 15 : 5))
  const hhi = portfolioStats?.hhi || 0.5
  const diversif = (() => { const _h = Math.max(0, Math.min(100, (0.40 - hhi) / 0.30 * 100)); const _c = portfolioStats?.correlation; let _v = []; if (_c) Object.entries(_c).forEach(([t,r]) => Object.entries(r).forEach(([t2,x]) => { if (t < t2) _v.push(Math.abs(x)) })); const _cm = _v.length ? _v.reduce((a,b)=>a+b,0)/_v.length : null; const _s = _cm === null ? _h : Math.max(0, Math.min(100, (0.60 - _cm) / 0.45 * 100)); return Math.round(_cm === null ? _h : _h*0.5 + _s*0.5) })()
  const weeklyTotal = etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)
  const weeklyPct = tv > 0 ? weeklyTotal/tv*100 : 0
  // multiplicador 3, nao 5: o commit 58eb53e de 04/08/2026
  // ("momentum menos sensivel") baixou de 5 para 3, mas a
  // troca so pegou no contexto da IA. O card ficou com o 5
  // de 12/07 ate 09/10/2026, entao a nota da tela e a que a
  // IA via divergiam: em semana de +10% a diferenca chegava
  // a 3 pontos de score, sempre para cima em semana boa.
  const momentum = Math.min(100, Math.max(0, 50 + weeklyPct * 3))
  const mcProb = parseFloat(portfolioStats?.monte_carlo?.prob_positive) || 0
  // mesma regua da analise da 🧠: a antiga zerava tudo abaixo de 30% de prob+
  const perspectiva = pilarPerspectiva(mcProb)
  return { estrutura, risco, diversif, momentum, perspectiva }
}
